import { AssigneeType, PostStatusPropertyValue, PropertyValue } from 'api/clients/PropertyClient'
import { Tag } from 'common/OptionSelect/Tag'
import { usePostProperties } from 'components/ArticlePostPreview/usePostProperties'
import { useScheduledPost } from 'hooks/queries/scheduledPosts/useScheduledPost'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import {
  STATUS_COLOR_V2,
  STATUS_FONT_COLOR_V2,
} from 'screens/ScheduledPosts/MobileCalendar/components/CalendarItem/CalendarItem'

interface Props {
  scheduledPostId?: number
  articleId: string
  size?: 'md' | 'sm'
  overrides?: Partial<Record<PostStatusPropertyValue, string>>
}

export const ScheduledPostStatusTag = ({ scheduledPostId, articleId, size, overrides }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { data: scheduledPost } = useScheduledPost({ id: scheduledPostId })
  const { status } = usePostProperties({ id: articleId, type: AssigneeType.Article })
  const statusColor = (status as PropertyValue)?.meta?.color as string

  const scheduledPostStatus = scheduledPost?.is_posting ? 'Posting' : scheduledPost?.status

  const postStatus = scheduledPost?.is_posting ? { value: 'Posting...' } : status
  const postStatusColor = scheduledPost?.is_posting ? '#ffefc5' : statusColor

  if (!isSystemRedesignEnabled && (!postStatus || !postStatusColor)) return null
  if (isSystemRedesignEnabled && !scheduledPostStatus) return null

  return (
    <Tag
      border={isSystemRedesignEnabled ? '1px solid var(--dark-4)' : undefined}
      size={size}
      color={isSystemRedesignEnabled && scheduledPostStatus ? STATUS_COLOR_V2[scheduledPostStatus] : postStatusColor}
      fontColor={isSystemRedesignEnabled && scheduledPostStatus ? STATUS_FONT_COLOR_V2[scheduledPostStatus] : undefined}
    >
      {isSystemRedesignEnabled && scheduledPostStatus
        ? scheduledPostStatus
        : overrides?.[postStatus?.value as PostStatusPropertyValue] || postStatus?.value}
    </Tag>
  )
}
